import { Component } from "./component";


/**
 * @category BCF
 */
export class Coloring {
    /**
     *  Color of the components
     */
    public color: string;

    /**
     * Colored components
     */
    public components: Component[];
}